import { Component, Inject } from '@angular/core'; 
import { MVCHTMLService } from './shared/services/mvc-html.service'; 
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './modules/authentication/services/auth.service';
import { DOCUMENT } from '@angular/common';
import { Globals } from './shared/global/globals';
import { TranslatorService } from './shared/services/translator.service';
import { environment } from "../environments/environment";
import Swal from 'sweetalert2/dist/sweetalert2.js';  
import { getMessaging, getToken, onMessage } from "firebase/messaging";
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {
  title = 'af-notification';
  message:any = null;
  list: any;
  arabicList:any;
  englishList:any;
  txtDir :string = 'ltr';
  public loading = false;
////////////////////////////////////////////////////////
  constructor(private globalVariable:Globals,public authService: AuthService,public translate: TranslateService
    ,public translateService: TranslatorService) {
      translate.addLangs(['Arabic', 'English']);
    let lang = this.authService.getSelectedLang();
    if(lang != null){
      translate.setDefaultLang(lang);
      if(lang =='Arabic'){
        this.txtDir = 'rtl';
      }else{
        this.txtDir = 'ltr';
      }
    }else{
      translate.setDefaultLang('English');
      this.txtDir = 'ltr';
    }
  }
////////////////////////////////////////////////////////
  ngOnInit(){ 
    this.getTranslator();
    this.listen();
  } 
////////////////////////////////////////////////////////
  getTranslator(){
    debugger;
    this.authService.generateTranslation().subscribe(res => { 
    debugger;
      for(let i of res){
        if(i.LanguageId =='1'){
          this.globalVariable.arabicTranslation[i.Key] = i.Value;
        }else{
          this.globalVariable.englishTranslation[i.Key] = i.Value;
        }
      }
    });
  } 
//////////////////////////////////////////////////
  listen() {
    const messaging = getMessaging();
    onMessage(messaging, (payload) => {
      console.log('Message received. ', payload);
      this.message=payload;
      var soundfile = "https://ecommercetest.boniantech.com/khayraat/content/notificationSound/message-ringtone-magic.mp3";
				Swal.fire({
				toast: true,
				title: payload.notification.title,
				text: payload.notification.body,
				position: 'bottom-start',
				showConfirmButton: false,
				timer: 6000,
				timerProgressBar: true,
				didOpen: (toast) => {
				  toast.addEventListener('mouseenter', Swal.stopTimer)
				  toast.addEventListener('mouseleave', Swal.resumeTimer)
          toast.addEventListener('click',  function (event) {
						event.preventDefault();
						window.location.href = payload.fcmOptions.link})
				  var audplay = new Audio(soundfile);
                  audplay.play();
				}
			  });
    });
  }
////////////////////////////////////////////
// requestPermission() {
//     const messaging = getMessaging();
//     getToken(messaging).then(
//        (currentToken) => {
//          if (currentToken) {
//           this.setTokenSentToServer(currentToken);
//           this.saveToken(currentToken)
//          } else {
//            console.log('No registration token available. Request permission to generate one.');
//          }
//      }).catch((err) => {
//         console.log('An error occurred while retrieving token. ', err);
//     });
//   }
//////////////////////////////////////////////////
// setTokenSentToServer(token) {
//   window.localStorage.setItem('fcmToken', token);
// }
//////////////////////////////////////////////////
// isTokenSentToServer() {
//   return window.localStorage.getItem('fcmToken');
// }
//////////////////////////////////////////////////
// saveToken(currentToken){
//   this.authService.saveToken(currentToken).subscribe(res => { 

//   });
// }
//////////////////////////////////////////////////
}
